
<form #loginForm="ngForm" class="re-form-container" (ngSubmit)="login(loginForm)" autocomplete="off" bdoScrollToInvalidControl [bdoScrollToInvalidControlForm]="loginForm" [attr.aria-label]="'aria.form.login' | translate">
  @if (isFetching) {
    <bdo-loading></bdo-loading>
  }

  <fieldset name="login-credentials" [attr.aria-label]="'aria.fieldset.loginCredentials' | translate">
    <div class="bdo-form-item-container">
      @switch (error) {
        @case ('notfound') {
          <div class="re-mb-10">
            <bdo-info-box>
              {{ 'login.error.userNotFound' | translate }}
            </bdo-info-box>
          </div>
        }
        @case ('general') {
          <div class="re-mb-10">
            <bdo-info-box>
              {{ 'general.error.error' | translate }}
            </bdo-info-box>
          </div>
        }
      }
      <div>
        @if (!userExistsInCognito) {
          <bdo-single-line-input
            #nameInput
            [inputName]="'name'"
            [placeholder]="'register.username.title' | translate"
            [labelText]="'register.username.title' | translate"
            [inputValue]="name"
            [autocomplete]="'username'"
            (inputValueChanged)="name=$event; onFocus();"
            (inputFocused)="onFocus()"
            [required]="true"
            [forceValidate]="validateAll"
            [validationIconHidden]="validationIconHidden"
            [errors]="[{text: ('register.username.required' | translate), name:'required'}]"
          ></bdo-single-line-input>
        }
        @if (userExistsInCognito) {
          <div class="re-form-item-container-row">
            <div>{{'register.username.title' | translate}}</div>
            <div>{{name}}</div>
          </div>
        }
      </div>
    </div>


    @if (userExistsInCognito) {
      <div class="bdo-form-item-container">
        <div>
          <bdo-single-line-input
            #passwordInput
            [inputName]="'password'"
            [inputValue]="password"
            [inputType]="'password'"
            [autocomplete]="'password'"
            [placeholder]="'register.password.title' | translate"
            [labelText]="'register.password.title' | translate"
            (inputValueChanged)="password=$event; onFocus();"
            (inputFocused)="onFocus()"
            [required]="true"
            [forceValidate]="validateAll"
            [validationIconHidden]="validationIconHidden"
          [errors]="[{text: ('register.password.required' | translate), name: 'required'},
                    {condition: password?.includes('<') || password?.includes('>'), text: ('register.password.htmlTags' | translate), name: 'htmlTagValidator'}]"
        ></bdo-single-line-input>

      </div>
    </div>
}

    @if (!userExistsInCognito) {
    <div>
      <button class="re-button re-primary bdo-button--text bdo-space--bottom re-block" type="submit" [disabled]="isFetching">
        {{ 'general.action.continue' | translate }}
      </button>
    </div>
    }
    @if (userExistsInCognito) {
      <div>
        <button class="re-button re-primary bdo-button--text bdo-space--bottom re-block" type="submit" [disabled]="isFetching">
          {{ 'login.title' | translate }}
        </button>
        <a class="bdo-link--inline"
          [routerLink]="'/passwort-vergessen'"
          [state]="{ username: name }"
          (click)="trackingService.postTracking(TRACKING.LOCATION.LOGIN, TRACKING.ACTION.GOTO, TRACKING.LOCATION.PASSWORD_FORGOT)">
          {{ 'password.forgot.title' | translate }}
        </a>
        <button class="bdo-link--inline re-block re-mt-15" type="button" [disabled]="isFetching" (click)="onCancel()">
          {{ 'general.action.cancel' | translate }}
        </button>
      </div>
    }
  </fieldset>

</form>
